import { makeStyles } from '@mui/styles';
import { ERROR, SHAMROCK } from '@returnmates/client-core/src/constants/colors';
import { SnackBarStatuses } from '@returnmates/client-core/src/type';
import { POPPINS } from '../../constants/styles/fonts';
var useStyles = makeStyles(function () { return ({
    root: {
        position: 'fixed',
        top: 35,
        zIndex: 1400,
        left: '50%',
        transform: 'translateX(-50%)',
    },
    snackBar: {
        position: 'relative',
        marginBottom: 10,
    },
    alert: function (_a) {
        var type = _a.type;
        return ({
            background: '#FFFFFF',
            border: type === SnackBarStatuses.SUCCESS ? "1px solid ".concat(SHAMROCK) : "1px solid ".concat(ERROR),
            borderRadius: 0,
        });
    },
    alertInner: function (_a) {
        var type = _a.type;
        return ({
            color: type === SnackBarStatuses.SUCCESS ? SHAMROCK : ERROR,
            marginRight: 30,
            fontFamily: POPPINS,
            fontWeight: 500,
            fontSize: 16,
            lineHeight: '160%',
            padding: '4px 0',
            width: 440,
        });
    },
    closeButton: {
        fontSize: 0,
        cursor: 'pointer',
    },
    closeIconWrapper: function (_a) {
        var type = _a.type;
        return ({
            position: 'absolute',
            top: '50%',
            right: 14,
            transform: 'translateY(-50%)',
            fontSize: '24px',
            lineHeight: 0,
            color: type === SnackBarStatuses.SUCCESS ? SHAMROCK : ERROR,
        });
    },
}); });
export default useStyles;
//# sourceMappingURL=styles.js.map